import { HomeHero } from "@/components/blocks/HomeHero";
import { QuoteBand } from "@/components/blocks/QuoteBand";
import { Statement } from "@/components/home/Statement";
import { Marquee } from "@/components/site/Marquee";
import { Pillars } from "@/components/home/Pillars";
import { Services } from "@/components/home/Services";
import { JourneySteps } from "@/components/blocks/JourneySteps";
import { FounderStory } from "@/components/blocks/FounderStory";
import { StoriesGrid } from "@/components/blocks/StoriesGrid";
import { ReviewStrip } from "@/components/home/ReviewStrip";
import { WhyUs, FaqTeaser } from "@/components/home/WhyUs";
import { ClosingBook } from "@/components/blocks/ClosingBook";
import { JsonLd, personSchema, usePageMeta } from "@/components/site/Seo";
import { Link } from "react-router-dom";

function StoriesTeaser() {
  return (
    <section data-testid="proof-section" className="bg-forest-deep py-24 text-cream sm:py-28">
      <div className="wrap">
        <div className="mb-10 flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <p className="eyebrow-dark">Client stories</p>
            <h2 className="mt-4 font-display text-5xl sm:text-6xl">Real people. <em className="text-gold-soft">Real progress.</em></h2>
          </div>
          <Link to="/success-stories" data-testid="proof-stories-link" className="link-line self-start text-sm font-semibold text-cream sm:self-auto">All success stories →</Link>
        </div>
        <StoriesGrid />
      </div>
    </section>
  );
}

export default function Home() {
  usePageMeta("Wellness Coach Sony Mathew | Nourish · Energise · Transform", "120-day Healthy Active Lifestyle Programme with wellness coach Sony Mathew in Kochi, Kerala. Free 20-minute consultation, no obligation.");
  return (
    <div data-testid="home-page">
      <JsonLd id="person" data={personSchema()} />
      <HomeHero />
      <QuoteBand />
      <Statement />
      <Marquee />
      <Pillars />
      <Services />
      <JourneySteps />
      <FounderStory />
      <StoriesTeaser />
      <ReviewStrip />
      <WhyUs />
      <FaqTeaser />
      <ClosingBook />
    </div>
  );
}
